<template>
    <div class="inviteregis-container">
        <div class="form-container">
            <van-button class="register-btn" @click="handleDownload">点击下载APP</van-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'inviteRegisterSuccess',
    data () {
        return {
        }
    },
    methods: {
        handleDownload () {
            this.$router.push('/download')
        }
    }
}
</script>

<style lang="less" scoped>
.inviteregis-container {
    width: 375px;
    background: url(../assets/inviteRegisterSuccess.png)top left/100% 100% no-repeat;
    background-size: 100%;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    position: absolute;
    min-height: 100%;
    .form-container {
        padding: 0 15px;
        margin-top: 165%;
        .register-btn {
            width: 100%;
            background: linear-gradient(180deg, #FF6763 0%, #F82A24 100%);
            border-radius: 8px;
            border: none;
            color: #fff;
            font-size: 16px;
        }
    }
}
</style>
